module.exports = __webpack_public_path__ + "static/media/staff-1.924c7382.jpg";